import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlusMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.989 13.255v-1.788H24v1.788h-6.011ZM16.614 4l-3.971 16.839H10.81l3.962-16.84h1.842ZM0 13.255v-1.788h9.731v1.788H0Zm3.972 3.99V7.476H5.76v9.767H3.972Z",
		fill: "currentColor"
	})
});
export default SvgPlusMinus;
